import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {ToastrService} from "ngx-toastr";
import {NgxSpinnerService} from "ngx-spinner";
import { LogService } from '../../../services/log.service';
@Component({
    selector: 'app-add-card-error',
    templateUrl: './add-card-error.component.html',
    styleUrls: ['./add-card-error.component.scss'],
    standalone: false
})
export class AddCardErrorComponent implements OnInit {

  constructor(private router: Router,private toastr: ToastrService,private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show();
    const redirectURL = localStorage.getItem('managecard')
    LogService.debug(redirectURL);
    this.toastr.error('Feil ved innlegging av kort', 'Legg til nytt');
    if(redirectURL){
      localStorage.setItem('add-card','error');
      this.router.navigateByUrl(redirectURL);
    }
    else{
      this.router.navigateByUrl('https://minside.nabonett.no');
    }
  }

}
